<template>
  <div>
 </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'posAuth',
    created () {
      this.$store.commit('AUTH_INIT_PUSHER')
      this.getAuthAccount()
    },
    methods: {
      ...mapActions([
        'getAuthAccount'
      ])
    },
    computed: {
      ...mapGetters({
        account: 'auth_get_account'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/setup/posAuth.vue